import { Injectable } from '@angular/core';

import {
	SubscriptionPreferences,
	UserPreferencesGeneral,
} from '@reach/interfaces/user/preferences.interface';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class EmailSubscriptionApiService extends BaseApiService {
	protected commonPath = ['settings', 'subscription'];

	public async getSubscriptionState(
		token: string
	): Promise<Pick<UserPreferencesGeneral, 'emailSubscriptions' | 'pushSubscriptions'>> {
		return await this.http.get<
			Pick<UserPreferencesGeneral, 'emailSubscriptions' | 'pushSubscriptions'>
		>(this.url(''), {}, { 'x-access-token': token });
	}

	public async editSubscriptionState(
		token: string,
		newState: Partial<SubscriptionPreferences>
	): Promise<void> {
		const body = { emailSubscriptions: newState };
		return await this.http.post<void>(this.url(''), body, {}, { 'x-access-token': token });
	}
}
